<template>
    <div class="row justify-content-center">
        <div class="col-md-10">
            <div class="row fotoDerecha my-0 my-lg-3" v-if="pos == 'fotoderecha'" data-aos="fade-up" data-aos-duration="1000">
                <div class="col-lg-6 text-left py-4">
                    <h3 v-html="titulo" v-if="titulo"></h3>
                    <div class="texto" v-html="texto"></div>
                </div>
                <div class="col-lg-6 pl-lg-5 m-0 contImagen">
                    <img :src="imagen" class="img-fluid" />
                </div>
            </div>
            <div class="row fotoIzquierda my-0 my-lg-3" v-if="pos == 'fotoizquierda'" data-aos="fade-up" data-aos-duration="1000">
                <div class="col-lg-6 text-left py-4 order-lg-12">
                    <h3 v-html="titulo" v-if="titulo"></h3>
                    <div class="texto" v-html="texto"></div>
                </div>
                <div class="col-lg-6 pr-lg-5 m-0 contImagen order-lg-1">
                    <img :src="imagen" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Fototextosombra',
  props: {
    titulo: String,
    texto: String,
    imagen: String,
    pos: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  font-weight: 700;
  font-size: 26px;
}
.texto {
    padding: 20px 40px;
    font-size: 16px;
    font-weight: 400;
}
.fotoDerecha img {
    /*-moz-box-shadow: 8px 8px 0 #000;
    -webkit-box-shadow: 8px 8px 0 #000;
    box-shadow: 8px 8px 0 #000;*/
}
.fotoIzquierda img {
    /*-moz-box-shadow: 8px 8px 0 #000;
    -webkit-box-shadow: 8px 8px 0 #000;
    box-shadow: 8px 8px 0 #000;*/
}
.contImagen {
    position: relative;
}
@media only screen and (max-width: 990px){
    h3 {
        font-size: 19px;
        margin-top: 15px;
        margin-left: 10px;
    }
    .texto {
        padding: 20px 30px;
    }
}
</style>
